import { Box, Paper as PaperMui } from '@common/components'
import { styled } from '@common/utils/styles'

export const Paper = styled(PaperMui)({
  padding: '15px',
  // width: '100%',
  // height: "100px",
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '10px',
})
export const SessionsWrapper = styled(Box)({
  // marginTop: '15px',
  borderRadius: '20px',
  height: 'calc(100vh - 150px)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  justifyContent: 'flex-start',
})

export const SessionPaper = styled(PaperMui)({
  padding: '15px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  overflowY: 'scroll',
  '::-webkit-scrollbar': {
    height: '10px',
    width: '7px',
    backgroundColor: 'transparent',
  },
  '::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(80, 80, 80, 0.1)',
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '5px',
    backgroundColor: 'rgba(30, 30, 30, 0.5)',
  },
})
